import { EventEmitter, Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { environment } from '../../../environments/environment';
import { ServiceBase } from './service-base.model';
import { catchError } from 'rxjs/operators';
import { BehaviorSubject, Observable, of, throwError } from 'rxjs';
import { JwtHelperService } from '@auth0/angular-jwt';
import { AddUserModel } from '../request/AddUserForDto.model';
import { UseUserIndexModel } from '../request/UseUserIndexForDto.model';
import { UpdateUserRoleModel } from '../request/UpdateUserRoleForDto.model';
import { LoginModel } from '../request/LoginForDto.model';
import { UseDealerCodeModel } from '../request/UseDealerCodeForDto.model';
import { UpdatePasswordModel } from '../request/UpdatePasswordForDto.model';

@Injectable({
  providedIn: 'root', // 全局提供服務
})
export class AuthUserService extends ServiceBase {

  baseUrl = environment.apiUrl + 'Auth/';
  userToken: any;
  decodedToken: any;
  jwtHelper: JwtHelperService = new JwtHelperService();
  public userName$: BehaviorSubject<string> =  new BehaviorSubject<string>("");
  public token$: BehaviorSubject<string> =  new BehaviorSubject<string>("");
  public loginNameEvent = new EventEmitter<string>();

  constructor(private http: HttpClient) {
    super();
  }

  set currentUser(value:string) {
    this.userName$.next(value); 
    localStorage.setItem('currenUserName', value);
  }

  get currentUser() {
    return localStorage.getItem('currenUserName') ?? "";
  }

  setAuth(authList: any) {
    localStorage.setItem('Auth', authList);
  }
  
  setSession(authResult: any) {
    this.userToken = authResult.Token;
    localStorage.setItem('Token', authResult.Token);
    this.decodedToken = this.jwtHelper.decodeToken(this.userToken);
    this.token$.next(authResult.Token);
    // const name = this.getCurrentUser();
    // this.currentUser = name;
  }

  getToken() {
    return localStorage.getItem('Token');
  }

  getDecodedToken() {
    const Token = this.getToken();
    return this.jwtHelper.decodeToken((Token == null ? undefined : Token));
  }
  
  getCurrentUser() {
    const decodedToken = this.getDecodedToken();
    if (decodedToken !== null) {
      return decodedToken.UserName;
    } else {
      return "";
    }
  }

  // 1.1.1 取得使用者清單 
  getUserListService() {
    return this.http.get(this.baseUrl + 'data', { headers: this.requestHeaders() })
    .pipe(catchError((err) => { return throwError(() => err); })); // );
  }

  // 1.1.2 新增一位使用者
  addUserService(model: AddUserModel) {
    return this.http.post(this.baseUrl + 'add', model, { headers: this.requestHeaders() })
    .pipe(catchError((err) => { return throwError(() => err); })); // );
  }

  // 1.1.3 修改使用者資料
  updateUserService(model: AddUserModel) {
    return this.http.post(this.baseUrl + 'edit', model, { headers: this.requestHeaders() })
    .pipe(catchError((err) => { return throwError(() => err); })); // );
  }

  // 1.1.4 刪除一位使用者
  deleteUserService(model: UseUserIndexModel) {
    return this.http.delete(this.baseUrl + 'delete' + '/' + model.UserIndex, { headers: this.requestHeaders() })
    .pipe(catchError((err) => { return throwError(() => err); })); // );
  }

  // 1.1.5 取得使用者所擁有的角色
  getUserRoleService(model: UseUserIndexModel) {
    return this.http.get(this.baseUrl + 'get/role' + '/' + model.UserIndex, { headers: this.requestHeaders() })
    .pipe(catchError((err) => { return throwError(() => err); })); // );
  }

  // 1.1.6 調整使用者對應的角色
  updateUserRoleService(model: UpdateUserRoleModel[]) {
    return this.http.post(this.baseUrl + 'edit/userrole', model, { headers: this.requestHeaders() })
    .pipe(catchError((err) => { return throwError(() => err); })); // );
  }

  // 1.1.7 使用者登入
  loginService(model: LoginModel) {
    console.log('baseUrl', this.baseUrl);
    return this.http.post(this.baseUrl + 'login', model, { headers: this.requestHeaders() })
    .pipe(catchError((err) => { return throwError(() => err); })); // );
    //return this.mockToken()
  }
  

  // 1.1.8 系統登入驗證使用者
  systemLoginService(model: LoginModel) {
    return this.http.post(this.baseUrl + 'system/login', model, { headers: this.requestHeaders() })
      .pipe(catchError((err) => { return throwError(() => err); }));
  }

  // 1.1.9 更新系統帳號的密碼
  updatePasswordService(model: UpdatePasswordModel) {
    return this.http.post(this.baseUrl + 'pass', model, { headers: this.requestHeaders() })
      .pipe(catchError((err) => { return throwError(() => err); }));
  }
  
  // 1.1.10 取得經銷商所屬人員
  getDealerUserService(model: UseDealerCodeModel) {
    return this.http.post(this.baseUrl + 'dealer', model, { headers: this.requestHeaders() })
      .pipe(catchError((err) => { return throwError(() => err); }));
  }

  getCaptcha(){
    var nDate = new Date();
    var vDate = nDate.getFullYear() +"/"+ (nDate.getMonth()+1) +"/"+ nDate.getDate() + " " + nDate.getHours() + ":" + nDate.getMinutes() + ":" + nDate.getSeconds();
    console.log('vDate', vDate);
    return this.http.get<any>(this.baseUrl + 'user/captcha', { headers: this.requestHeaders() })
      .pipe(catchError((err) => { return throwError(() => err); })); // .catch(this.handleError);
  }


  mockToken(){
    const response: ResponseModel = {
      UserName: "林測試", // 中文或特殊字元
      userPhone: "04-12345678",
      userMobile: "0987-654321"
    };
  
    // 將 header 和 payload 進行 Base64 編碼
    const header = { alg: 'HS256', typ: 'JWT' };
    const payload = response;
  
    const encodedHeader = this.utf8ToBase64(JSON.stringify(header));
    const encodedPayload = this.utf8ToBase64(JSON.stringify(payload));
  
    // 模擬 signature（僅用來示範）
    const signature = 'mock-signature';
  
    const Token = `${encodedHeader}.${encodedPayload}.${signature}`;
  
    console.log('Generated Token:', Token);
    return of({ Token }); // 返回模擬的 JWT Token
  }


  // UTF-8 to Base64 編碼函數
  utf8ToBase64(str: string): string {
    return btoa(unescape(encodeURIComponent(str)));
  }

  // Base64 to UTF-8 解碼函數
  base64ToUtf8(base64: string): string {
    return decodeURIComponent(escape(atob(base64)));
  }

}


interface ResponseModel {
  UserName: string;
  userPhone: string;
  userMobile: string;
}